function importAll(request) {
  return request.keys().map((item) => {
    const match = item.match(/\.\/(?<domain>.*)\.(?:png|jpe?g|svg)$/);
    const domain = match?.groups?.domain || item.replace(/^\.\/|(\.\w+)$/g, '');
    return {
      domain,
      image: request(item).default,
    };
  });
}

const images = importAll(require.context('./assets', false, /\.(png|jpe?g|svg)$/));

export default function getLogoFallback(url) {
  const { hostname } = new URL(url);
  const { image } = images.find(({ domain }) => hostname.includes(domain)) || {};
  return image;
}
